import { format } from "date-fns";
import { DateTime } from "luxon";
// import * as Sentry from "@sentry/react";

export function parseDateTime(dateTime: string, _exceptionMsg: string) {
  // replace all spaces with T to make it ISO 8601 compliant
  const parsedDate = DateTime.fromISO(dateTime.replaceAll(" ", "T"));
  if (!parsedDate.isValid) {
    // const err = new Error(exceptionMsg);
    // Sentry.captureException(err);
  }
  return parsedDate;
}

export function stripTimeFromDate(date: Date) {
  return date.toISOString().split("T")[0];
}

export function formatDateRange(start: Date, end: Date) {
  return `${format(start, "MM/dd/yyyy")} - ${format(end, "MM/dd/yyyy")}`;
}

export function formatDateTime(dateTime: DateTime, format?: string) {
  if (!dateTime.isValid) {
    return "";
  }
  format = format ?? "dd-LL-yyyy HH:mm";
  return dateTime.toFormat(format);
}

/**
 * Formats the relative time string e.g. "2 days ago".
 */
export function getTimeAgo(pastDateTime: DateTime) {
  return pastDateTime.toRelative({ style: "short" });
}

/**
 * Gets the relative time string e.g. "2 days ago" and formats to a shorter version e.g. "2d".
 */

export function getTimeAgoShortened(time: string) {
  return getTimeAgo(parseDateTime(time ?? "", ""))
    ?.replace(" ago", "")
    .replace("days", "d")
    .replace("day", "d")
    .replace("hr", "h")
    .replace("min", "m")
    .replace("sec", "s")
    .replace(" ", "");
}

/**
 * Formats the timestamp as 'dd month (short) year, HH:mm' e.g. '24 Mar 2021, 11:30'
 */
export function formatTimestamp(time: string) {
  return `${new Date(time).toLocaleDateString("default", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })}`;
}

export function jsDateFromSeparateParts(
  dateDateObject: Date,
  timeDateObject: Date,
  timezone: string
) {
  return DateTime.fromObject(
    {
      year: dateDateObject.getFullYear(),
      month: dateDateObject.getMonth() + 1,
      day: dateDateObject.getDate(),
      hour: timeDateObject.getHours(),
      minute: timeDateObject.getMinutes(),
      second: timeDateObject.getSeconds(),
    },
    { zone: timezone }
  ).toJSDate();
}

export function parseDate(dateTime: string | undefined | null) {
  if (!dateTime) return undefined;
  return new Date(dateTime);
}

export function formatDate(date?: Date) {
  if (!date) return "";
  return date.toLocaleDateString("default", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatOnlyDate(date: Date) {
  return new Date(date)?.toLocaleDateString("default", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatOnlyTime(date: Date) {
  return new Date(date)?.toLocaleTimeString("default", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
